import styled from "styled-components";
import { AnchorContainer as AnchorContainerUI } from "@evergis/ui";
import background from "../../assets/background.png";

export const ColorWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  height: 2rem;
`;

export const ColorButton = styled.div<{ width?: string }>`
  display: flex;
  flex-grow: 1;
  min-width: 1.5rem;
  height: 1.5rem;
  margin: 0 0.25rem;
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  overflow: hidden;
  width: ${({ width }) => width};
  border: 1px solid #f0f0f0;
  box-sizing: border-box;
  background: url(${background});
`;

export const ColorItem = styled.div<{ color?: string }>`
  display: flex;
  flex-grow: 1;
  background-color: ${({ color }) => color};
`;

export const AnchorContainer = styled(AnchorContainerUI)`
  width: ${({ width }: { width: string }) => width || "4rem"};
`;
